import { createQueryKeys } from '@lukemorales/query-key-factory';

export const suspectKeys = createQueryKeys('suspects', {
  create: null,
  update: null,
  delete: null,
  all: (filter) => ({
    queryKey: [filter],
  }),
  detail: (id) => ({
    queryKey: [id],
  }),
  searchByName: (filter) => ({
    queryKey: [filter],
  }),
});
